import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { User } from '../types/user.type';
import { ADMIN_USERS_API_PATHS } from '../constants/users-paths.constants';

type UseDeactivateUserResult = {
  deactivateUser: (userId: string) => Promise<User | null>;
  isSubmitting: boolean;
};

export function useDeactivateUser(): UseDeactivateUserResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const deactivateUser = async (userId: string): Promise<User | null> => {
    setIsSubmitting(true);

    try {
      const deactivatedUser = await HttpClient.delete<User>(ADMIN_USERS_API_PATHS.DEACTIVATE_USER(userId));

      enqueueSnackbar('Client désactivé', { variant: 'success' });
      return deactivatedUser;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la désactivation du client'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { deactivateUser, isSubmitting };
}
